import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "owa-truetime"*/ './lazyIndex')
);

// Module
export const lazyInitializeTrueTimeStore = new LazyAction(
    lazyModule,
    m => m.initializeTrueTimeStore
);

// Actions
export { updateMergedViewAvailabilityAccountCompleted } from './actions/publicActions';

// Selectors
export const lazyGetMergeViewEnabledAccount = new LazyImport(
    lazyModule,
    m => m.getMergeViewEnabledAccount
);
export const lazyGetStoreIsSettled = new LazyImport(lazyModule, m => m.getStoreIsSettled);
export const lazyGetStoreState = new LazyImport(lazyModule, m => m.getStoreState);

// Utils
export const lazyAddMergedViewAvailabilityAccount = new LazyImport(
    lazyModule,
    m => m.addMergedViewAvailabilityAccount
);
export const lazyRemoveMergedViewAvailabilityAccount = new LazyImport(
    lazyModule,
    m => m.removeMergedViewAvailabilityAccount
);

// Types
export { State } from './store/schema/State';
